import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useIsMobileViewport } from '../../hooks/useIsMobileViewport'
import { getSupportContact } from '../../support/supportApi'

function WhatsAppIcon() {
  return (
    <svg
      aria-hidden="true"
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="currentColor"
      focusable="false"
    >
      <path d="M20.5 3.5A11.8 11.8 0 0 0 12.05 0C5.46 0 .1 5.36.1 11.95c0 2.1.55 4.15 1.6 5.95L0 24l6.25-1.64a11.94 11.94 0 0 0 5.8 1.48h.01C18.64 23.84 24 18.48 24 11.9c0-3.18-1.24-6.16-3.5-8.4Zm-8.45 18.32a9.9 9.9 0 0 1-5.06-1.39l-.36-.21-3.71.97.99-3.62-.23-.37a9.84 9.84 0 0 1-1.52-5.25c0-5.45 4.44-9.89 9.9-9.89a9.82 9.82 0 0 1 7 2.9 9.82 9.82 0 0 1 2.89 6.99c0 5.45-4.44 9.87-9.9 9.87Zm5.42-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47a8.9 8.9 0 0 1-1.65-2.05c-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.21 5.1 4.5.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.58-.08 1.76-.72 2.01-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35Z" />
    </svg>
  )
}

export function WhatsAppSupportButton() {
  const { t } = useTranslation()
  const isMobile = useIsMobileViewport()
  const [whatsappNumber, setWhatsappNumber] = useState<string | null>(null)

  useEffect(() => {
    let active = true

    getSupportContact()
      .then(contact => {
        if (active) setWhatsappNumber(contact.whatsappNumber)
      })
      .catch(() => {
        if (active) setWhatsappNumber(null)
      })

    return () => {
      active = false
    }
  }, [])

  if (!whatsappNumber) return null

  const digits = whatsappNumber.replace(/\D/g, '')
  if (!digits) return null

  const label = t('support.whatsapp.open')

  return (
    <div
      data-whatsapp-support-button
      style={{
        position: 'fixed',
        insetInline: 0,
        bottom: isMobile
          ? 'calc(20px + var(--mobile-sticky-cta-height, 0px) + env(safe-area-inset-bottom))'
          : 24,
        zIndex: 'var(--z-dropdown)',
        pointerEvents: 'none',
      }}
    >
      <a
        href={`https://wa.me/${digits}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        title={label}
        style={{
          position: 'absolute',
          insetInlineEnd: isMobile ? 16 : 24,
          bottom: 0,
          width: isMobile ? 48 : 52,
          height: isMobile ? 48 : 52,
          display: 'grid',
          placeItems: 'center',
          borderRadius: '50%',
          background: 'var(--success)',
          color: 'var(--white)',
          boxShadow: 'var(--shadow-lg)',
          border: '2px solid var(--white)',
          textDecoration: 'none',
          pointerEvents: 'auto',
        }}
      >
        <WhatsAppIcon />
      </a>
    </div>
  )
}
